import { render, staticRenderFns } from "./PdfDocument.vue?vue&type=template&id=3b48d95d"
import script from "./PdfDocument.vue?vue&type=script&lang=js"
export * from "./PdfDocument.vue?vue&type=script&lang=js"
import style0 from "./PdfDocument.vue?vue&type=style&index=0&id=3b48d95d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports